import React from 'react';

import EmptyGoodsIcon from 'assets/empty-goods-icon';

import { EmptyStateContainer, StyledHeader, StyledTextButton } from './empty-state-shared-styles';

type OrdersErrorStateProps = {
  onRefetch: () => void;
  loading: boolean;
};

export function OrdersErrorState({ onRefetch, loading }: OrdersErrorStateProps): JSX.Element {
  return (
    <EmptyStateContainer data-testid='orders-error-state'>
      <EmptyGoodsIcon />
      <StyledHeader>Cannot display orders at this time</StyledHeader>
      <StyledTextButton data-testid='orders-error-refresh' onClick={onRefetch} disabled={loading}>
        Refresh
      </StyledTextButton>
    </EmptyStateContainer>
  );
}
